import React, { useState, useEffect } from "react";
import { useGetTablesdataMutation } from "./TablesourceApiSlice";

const TableSource = ({
  setNickName,
  connectionId,
  selectedTable,
  nickName,
}) => {
  console.log(nickName);

  const [getTablesdata, { data, isLoading, isError, isSuccess }] =
    useGetTablesdataMutation();

  console.log(data);

  const [input, setInput] = useState(selectedTable);
  console.log(input);

  useEffect(() => {
    getTablesdata({ selectedTable, connectionId });
  }, [selectedTable, connectionId]);

  const handleInputChange = (e) => {
    setInput(e.target.value);
    setNickName(e.target.value);
  };
  let tableContent;
  if (isLoading) {
    tableContent = <p>Loading...</p>;
  } else if (isError) {
    tableContent = <p>Cannot fetch the data</p>;
  } else if (isSuccess) {
    const { mappedColumnArray } = data;
    tableContent = (
      <section className="flex flex-col gap-2 h-[40rem] lg:h-full w-full lg:w-[30%] ">
        <div className="flex w-full items-center justify-start">
          <label className="font-medium">TableName :</label>
          <input
            type="text"
            placeholder="Enter value"
            className="border-b border-gray-200 rounded pl-1 outline-none text-blue-950"
            value={input}
            onChange={handleInputChange}
          />
        </div>

        <table className="border border-gray-300 border-collapse w-full text-sm">
          <thead className="sticky top-0 bg-gray-200 mb-[2px]">
            <tr>
              <th className="border border-gray-300 text-left px-1 text-blue-950 font-bold">
                Column Name
              </th>
              <th className="border border-gray-300 text-left px-1 text-blue-950 font-bold">
                Data Type
              </th>
            </tr>
          </thead>
          <tbody className="overflow-auto">
            {mappedColumnArray.map((column, index) => (
              <tr
                key={index}
                className={`border-none ${
                  index % 2 === 0 ? "bg-gray-100" : "bg-white"
                }`}
              >
                <td className="border border-gray-300 text-left pl-1">
                  {column.rename}
                </td>
                <td className="border border-gray-300 text-left pl-1">
                  {column.dataType}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </section>
    );
  }
  return <>{tableContent}</>;
};
export default TableSource;
